  <div class="content-page dark">
    <!-- Content header -->
    <header>
      <!-- Navigation
        - This will be displayed optionally if engine requires so
        - Number of links will differ based on flags set in engine
        - Styles will make final link listed a 'button' style
      -->
      <nav>
        <a *ngIf="hasContent" href="/Page#/claim?pId={{content.ContentDetail.OwnerID}}&ckey={{content.ContentDetail.ContentPageID}}">Register</a>
      </nav>
      <div id="contentHead" class="row centered">
        <!-- Site logo -->
        <a href="#" class="site-logo"></a>
        <!-- Page header -->
        <h1>
          <div *ngIf="hasContent" [innerHtml]="content.ContentPage.pageTitle | safeHtml"></div>                         <!-- 07-24-2021 - dwn: changed from .title to .pageTitle -->
        </h1>
        <h2 *ngIf="showError">
           <!-- passing errors in title right now for debugging -->
          {{content.ContentPage.title}}
        </h2>
      </div>
    </header>
    <!-- Main area for content sections -->
    <main>
      <div id="contentBody" class="row" *ngIf="hasContent && sectionCount > 0">
        <app-content-section *ngFor="let section of content.ContentSections" [ngClass]="{'loading': section.isLoaded}" [section]="section"></app-content-section>
      </div>
      <div id="contentBody" class="row" *ngIf="!isLoading && sectionCount === 0">
        <b>[No Content]</b>
      </div>
    </main>
  </div>
